var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-black text-uppercase rounded",attrs:{"text-color":_vm.color,"color":_vm.color + 26,"label":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }